
import ForgotPassword from "../../pages/auth/forgot-password"
import NotFound from "../../pages/auth/NotFound"
import ResetPassword from "../../pages/auth/reset-password"
import { RoleGuard } from "../guards"
import IshipxHome from "../../pages/shipx"


export const LxRoutes = () => {
    return (
        [
            { path: "", element: <RoleGuard roles={["customer"]}><IshipxHome /></RoleGuard> },
            { path: "login/forgot-password", element: <RoleGuard roles={["Internal"]}><ForgotPassword /></RoleGuard> },
            { path: "login/reset-password", element: <RoleGuard roles={["Internal"]}><ResetPassword /></RoleGuard> },

        ]
    )
}

